<h2 mat-dialog-title>Czy jesteś pewny że chcesz usunąć ceny?</h2>
<div mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Anuluj</button>
    <button mat-button (click)="confirmDelete()" cdkFocusInitial>Usuń ceny</button>
</div>
